import classNames from "classnames";
import { Logo } from "@resources";
import { Constants } from "@shared";

interface PageFooterProps {
    id?: string;
    className?: string;
}

const PageFooter: React.FC<PageFooterProps> = ({ id, className }) => (
    <footer id={id} className={classNames(
        `relative bg-neutral-50 border-t border-neutral-100 px-4 pt-2.5 pb-4 md:px-8 md:py-6 w-full`,
        className
    )}>
        {/* Desktop Layout */}
        <div className="hidden md:flex items-center justify-between">
            <div className="flex gap-1 items-start" role="img" aria-label="Powered by Sunbound">
                <span className="text-neutral-950 text-[10px] leading-[12px]">Powered by</span>
                <Logo className="h-4 w-auto text-neutral-950" />
            </div>
            <span className="text-neutral-500 text-[10px] leading-[12px]">All rights reserved. © Sunbound {new Date().getFullYear()}</span>
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex gap-6">
                <a href={`mailto:${Constants.Help.Email}?subject=Help with Sunbound Pay`} className="font-medium text-sm text-neutral-900 focus-visible:outline-focus-ring rounded">Email Support</a>
                <a href={Constants.Help.FAQ} target="_blank" rel="noreferrer" className="font-medium text-sm text-neutral-900 focus-visible:outline-focus-ring rounded">FAQ</a>
                <a href={Constants.Help.Privacy} target="_blank" rel="noreferrer" className="font-medium text-sm text-neutral-900 focus-visible:outline-focus-ring rounded">Privacy Policy</a>
            </div>
        </div>
        {/* Mobile Layout */}
        <div className="flex md:hidden justify-between">
            <div className="flex flex-col gap-1 pt-0.5">
                <div className="flex gap-1 items-center" role="img" aria-label="Powered by Sunbound">
                    <span className="text-neutral-950 text-[10px] leading-[12px]">Powered by</span>
                    <Logo className="h-4 w-auto text-neutral-950" />
                </div>
                <span className="text-neutral-500 text-[10px] leading-[12px]">All rights reserved. © Sunbound {new Date().getFullYear()}</span>
            </div>
            <div className="flex flex-col gap-1 items-end">
                <a href={`mailto:${Constants.Help.Email}?subject=Help with Sunbound Pay`} className="font-medium text-xs text-neutral-900 focus-visible:outline-focus-ring rounded">Email Support</a>
                <div className="flex gap-4">
                    <a href={Constants.Help.FAQ} target="_blank" rel="noreferrer" className="font-medium text-xs text-neutral-900 focus-visible:outline-focus-ring rounded">FAQ</a>
                    <a href={Constants.Help.Privacy} target="_blank" rel="noreferrer" className="font-medium text-xs text-neutral-900 focus-visible:outline-focus-ring rounded">Privacy Policy</a>
                </div>
            </div>
        </div>
    </footer>
);

export default PageFooter;
